module.exports = __webpack_public_path__ + "media/assets/images/logos/logo_cimentos-b70187da329e2e673d2c339009ae1dd0.png";